import { useReducer, useCallback } from 'react';
import { EventBusContext, SEVERITY, CATEGORY } from '../hooks/useEventBus.js';

const MAX_EVENTS = 200;
let _idCounter = 0;

function reducer(state, action) {
  switch (action.type) {
    case 'PUSH': {
      const event = {
        id:           ++_idCounter,
        ts:           Date.now(),
        severity:     action.severity || SEVERITY.INFO,
        category:     action.category || CATEGORY.SYSTEM,
        title:        action.title    || '',
        body:         action.body     || '',
        norad_1:      action.norad_1  || null,
        norad_2:      action.norad_2  || null,
        lat:          action.lat      || null,
        lon:          action.lon      || null,
        acknowledged: false,
      };
      return { ...state, events: [event, ...state.events].slice(0, MAX_EVENTS) };
    }
    case 'ACK':
      return { ...state, events: state.events.map(e => e.id === action.id ? { ...e, acknowledged: true } : e) };
    case 'ACK_ALL':
      return { ...state, events: state.events.map(e => ({ ...e, acknowledged: true })) };
    case 'CLEAR':
      return { ...state, events: [] };
    default:
      return state;
  }
}

export default function EventBusProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, { events: [] });
  const push   = useCallback((event) => dispatch({ type: 'PUSH', ...event }),  []);
  const ack    = useCallback((id)    => dispatch({ type: 'ACK',  id }),        []);
  const ackAll = useCallback(()      => dispatch({ type: 'ACK_ALL' }),          []);
  const clear  = useCallback(()      => dispatch({ type: 'CLEAR' }),            []);
  return (
    <EventBusContext.Provider value={{ events: state.events, push, ack, ackAll, clear }}>
      {children}
    </EventBusContext.Provider>
  );
}
